import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import styled from '@emotion/styled';
import { getId } from '../Field/Field';
import { fieldMaxWidth, StyledFieldSet, StyledLegend } from '../Field/Field.styled';
import { Tooltip } from '../Tooltip';
import { useTranslate } from '../util';
import { Radio } from './Checkbox';
var StyledOption = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\tmargin-right: 18px;\n"])));
/** @deprecated use `Toggle` or `Checkbox` instead */
export function YesNoField(props) {
  var t = useTranslate();
  var name = getId({});
  var maxWidth = props.maxWidth || fieldMaxWidth;
  return /*#__PURE__*/React.createElement(StyledFieldSet, {
    disabled: props.disabled,
    style: {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React.createElement(StyledLegend, {
    style: {
      maxWidth: maxWidth
    },
    as: "legend"
  }, props.label, props.tooltip && /*#__PURE__*/React.createElement(Tooltip, null, props.tooltip)), /*#__PURE__*/React.createElement(StyledOption, null, /*#__PURE__*/React.createElement(Radio, {
    checked: props.checked,
    disabled: props.disabled,
    onChange: function onChange() {
      return props.onChange(true);
    },
    name: name
  }, t('citrix-ui:yes'))), /*#__PURE__*/React.createElement(StyledOption, null, /*#__PURE__*/React.createElement(Radio, {
    checked: !props.checked,
    disabled: props.disabled,
    onChange: function onChange() {
      return props.onChange(false);
    },
    name: name
  }, t('citrix-ui:no'))));
}